<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <el-col v-show="false">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  placeholder="搜索关键词"
                  @keyup.enter.native="queryTableData"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择"
                  style="width: 100px"
                  @change="queryTableData"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button type="primary" @click="queryTableData"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </el-col>

          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
          :tree-props="{ children: 'menus' }"
      >
        <el-table-column prop="name" label="名称" width="180" align="left">
        </el-table-column>
        <el-table-column prop="typeName" label="类型" align="center" width="100">
        </el-table-column>
        <el-table-column prop="icon" label="图标" align="center" width="100">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
        <el-table-column prop="seq" label="排序" align="center" width="100">
        </el-table-column>
        <el-table-column prop="code" label="标识" align="center">
        </el-table-column>
        <el-table-column prop="view" label="路由" align="center">
        </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeSwitch(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="editShow || deleteShow " width="150" align="right">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="warning"
                plain
                v-if="editShow"
            >编辑
            </el-button
            >
            <el-button
                size="mini"
                @click="handleDelete(scope.row)"
                type="primary"
                plain
                v-if="deleteShow"
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="添加/编辑菜单"
        :visible.sync="dialogVisible"
        width="460px"
        class="public-dialog"
        :close-on-click-modal="false"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item class="item" label="类型：" prop="type">
            <el-radio :disabled="this.clickType=='edit'" v-model="params.type" :label="5">目录</el-radio>
            <el-radio :disabled="this.clickType=='edit'" v-model="params.type" :label="10">菜单</el-radio>
            <el-radio :disabled="this.clickType=='edit'" v-model="params.type" :label="20">按钮</el-radio>
          </el-form-item>

          <el-form-item label="上级：" style="position: relative">
            <span class="clear_icon_items">*</span>
            <el-select
                v-model="dictDataSelect"
                placeholder="请选择"
                ref="selectReport"
                style="width: 315px"
                clearable
            >
              <el-option
                  :key="params.menuId"
                  :value="params.menuId"
                  :label="params.menuId"
                  style="height: auto"
              >
                <el-tree
                    :data="selectData"
                    node-key="menuId"
                    ref="TreeList"
                    :props="treeProps"
                    :render-after-expand="true"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                ></el-tree>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="item" label="名称：" prop="name">
            <el-input
                placeholder="请填写名称"
                v-model="params.name"
                clearable
            ></el-input>
          </el-form-item>

          <el-form-item prop="code" class="item" label="标识：" v-if="params.type==20">
            <el-input
                placeholder="请填写标识"
                v-model="params.code"
                clearable
                :disabled="clickType=='edit'"
            ></el-input>
          </el-form-item>

          <el-form-item class="item" v-if="params.type!=20" label="路由：" prop="view">
            <el-input
                placeholder="请填写路由"
                v-model="params.view"
                clearable
            ></el-input>
          </el-form-item>
          <div class="from_box">
            <el-form-item class="item" label="排序：" prop="seq">
              <el-input
                  style="width: 100px"
                  placeholder="请填写排序序号"
                  v-model.number="params.seq"
              ></el-input>
            </el-form-item>
            <el-form-item class="item" label="图标：" prop="icon">
              <div @click="iconVisible=true" style="font-size: 30px">
                <i :class="params.icon" v-if="params.icon"></i>
                <i class="el-icon-folder-add" v-else></i>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>

    <!--icon库-->
    <el-dialog
        title="icon库选择"
        :visible.sync="iconVisible"
        width="870px"
        class="public-dialog"
        :close-on-click-modal="false"
    >
      <div class="public-dialog-form">
        <ul class="icon-list">
          <li @click="changActive(item)" :class="{'active_info':item.className==params.icon}"
              v-for="(item,index) in iconList"
              :key="index">
            <span><i :class="item.className"></i><span class="icon-name">{{ item.className }}</span></span>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {isEmpty} from "@utils/tools/index";

export default {
  data() {
    return {
      iconList: [
        {
          className: 'el-icon-platform-eleme'
        },
        {
          className: 'el-icon-eleme'
        },
        {
          className: 'el-icon-delete-solid'
        },
        {
          className: 'el-icon-delete'
        },
        {
          className: 'el-icon-s-tools'
        },
        {
          className: 'el-icon-setting'
        },
        {
          className: 'el-icon-user-solid'
        },
        {
          className: 'el-icon-user'
        },
        {
          className: 'el-icon-phone'
        },
        {
          className: 'el-icon-phone-outline'
        },
        {
          className: 'el-icon-more'
        },
        {
          className: 'el-icon-more-outline'
        },
        {
          className: 'el-icon-star-on'
        },
        {
          className: 'el-icon-star-off'
        },
        {
          className: 'el-icon-s-goods'
        },
        {
          className: 'el-icon-goods'
        },
        {
          className: 'el-icon-warning'
        },
        {
          className: 'el-icon-warning-outline'
        },
        {
          className: 'el-icon-question'
        },
        {
          className: 'el-icon-info'
        },
        {
          className: 'el-icon-remove'
        },
        {
          className: 'el-icon-circle-plus'
        },
        {
          className: 'el-icon-success'
        },
        {
          className: 'el-icon-error'
        },
        {
          className: 'el-icon-zoom-in'
        },
        {
          className: 'el-icon-zoom-out'
        },
        {
          className: 'el-icon-remove-outline'
        },
        {
          className: 'el-icon-circle-plus-outline'
        },
        {
          className: 'el-icon-circle-check'
        },
        {
          className: 'el-icon-circle-close'
        },
        {
          className: 'el-icon-s-help'
        },
        {
          className: 'el-icon-help'
        },
        {
          className: 'el-icon-minus'
        },
        {
          className: 'el-icon-plus'
        },
        {
          className: 'el-icon-check'
        },
        {
          className: 'el-icon-close'
        },
        {
          className: 'el-icon-picture'
        },
        {
          className: 'el-icon-picture-outline'
        },
        {
          className: 'el-icon-picture-outline-round'
        },
        {
          className: 'el-icon-upload'
        },
        {
          className: 'el-icon-upload2'
        },
        {
          className: 'el-icon-download'
        },
        {
          className: 'el-icon-camera-solid'
        },
        {
          className: 'el-icon-camera'
        },
        {
          className: 'el-icon-video-camera-solid'
        },
        {
          className: 'el-icon-video-camera'
        },
        {
          className: 'el-icon-message-solid'
        },
        {
          className: 'el-icon-bell'
        },
        {
          className: 'el-icon-s-cooperation'
        },
        {
          className: 'el-icon-s-order'
        },
        {
          className: 'el-icon-s-platform'
        },
        {
          className: 'el-icon-s-fold'
        },
        {
          className: 'el-icon-s-unfold'
        },
        {
          className: 'el-icon-s-operation'
        },
        {
          className: 'el-icon-s-promotion'
        },
        {
          className: 'el-icon-s-home'
        },
        {
          className: 'el-icon-s-release'
        },
        {
          className: 'el-icon-s-ticket'
        },
        {
          className: 'el-icon-s-management'
        },
        {
          className: 'el-icon-s-open'
        },
        {
          className: 'el-icon-s-shop'
        },
        {
          className: 'el-icon-s-marketing'
        },
        {
          className: 'el-icon-s-flag'
        },
        {
          className: 'el-icon-s-comment'
        },
        {
          className: 'el-icon-s-finance'
        },
        {
          className: 'el-icon-s-claim'
        },
        {
          className: 'el-icon-s-custom'
        },
        {
          className: 'el-icon-s-opportunity'
        },
        {
          className: 'el-icon-s-data'
        },
        {
          className: 'el-icon-s-check'
        },
        {
          className: 'el-icon-s-grid'
        },
        {
          className: 'el-icon-menu'
        },
        {
          className: 'el-icon-share'
        },
        {
          className: 'el-icon-d-caret'
        },
        {
          className: 'el-icon-caret-left'
        },
        {
          className: 'el-icon-caret-right'
        },
        {
          className: 'el-icon-caret-bottom'
        },
        {
          className: 'el-icon-caret-top'
        },
        {
          className: 'el-icon-bottom-left'
        },
        {
          className: 'el-icon-bottom-right'
        },
        {
          className: 'el-icon-back'
        },
        {
          className: 'el-icon-right'
        },
        {
          className: 'el-icon-bottom'
        },
        {
          className: 'el-icon-top'
        },
        {
          className: 'el-icon-top-left'
        },
        {
          className: 'el-icon-top-right'
        },
        {
          className: 'el-icon-arrow-left'
        },
        {
          className: 'el-icon-arrow-right'
        },
        {
          className: 'el-icon-arrow-down'
        },
        {
          className: 'el-icon-arrow-up'
        },
        {
          className: 'el-icon-d-arrow-left'
        },
        {
          className: 'el-icon-d-arrow-right'
        },
        {
          className: 'el-icon-video-pause'
        },
        {
          className: 'el-icon-video-play'
        },
        {
          className: 'el-icon-refresh'
        },
        {
          className: 'el-icon-refresh-right'
        },
        {
          className: 'el-icon-refresh-left'
        },
        {
          className: 'el-icon-finished'
        },
        {
          className: 'el-icon-sort'
        },
        {
          className: 'el-icon-sort-up'
        },
        {
          className: 'el-icon-sort-down'
        },
        {
          className: 'el-icon-rank'
        },
        {
          className: 'el-icon-loading'
        },
        {
          className: 'el-icon-view'
        },
        {
          className: 'el-icon-c-scale-to-original'
        },
        {
          className: 'el-icon-date'
        },
        {
          className: 'el-icon-edit'
        },
        {
          className: 'el-icon-edit-outline'
        },
        {
          className: 'el-icon-folder'
        },
        {
          className: 'el-icon-folder-opened'
        },
        {
          className: 'el-icon-folder-add'
        },
        {
          className: 'el-icon-folder-remove'
        },
        {
          className: 'el-icon-folder-delete'
        },
        {
          className: 'el-icon-folder-checked'
        },
        {
          className: 'el-icon-tickets'
        },
        {
          className: 'el-icon-document-remove'
        },
        {
          className: 'el-icon-document-delete'
        },
        {
          className: 'el-icon-document-copy'
        },
        {
          className: 'el-icon-document-checked'
        },
        {
          className: 'el-icon-document'
        },
        {
          className: 'el-icon-document-add'
        },
        {
          className: 'el-icon-printer'
        },
        {
          className: 'el-icon-paperclip'
        },
        {
          className: 'el-icon-takeaway-box'
        },
        {
          className: 'el-icon-search'
        },
        {
          className: 'el-icon-monitor'
        },
        {
          className: 'el-icon-attract'
        },
        {
          className: 'el-icon-mobile'
        },
        {
          className: 'el-icon-scissors'
        },
        {
          className: 'el-icon-umbrella'
        },
        {
          className: 'el-icon-headset'
        },
        {
          className: 'el-icon-brush'
        },
        {
          className: 'el-icon-mouse'
        },
        {
          className: 'el-icon-coordinate'
        },
        {
          className: 'el-icon-magic-stick'
        },
        {
          className: 'el-icon-reading'
        },
        {
          className: 'el-icon-data-line'
        },
        {
          className: 'el-icon-data-board'
        },
        {
          className: 'el-icon-pie-chart'
        },
        {
          className: 'el-icon-data-analysis'
        },
        {
          className: 'el-icon-collection-tag'
        },
        {
          className: 'el-icon-film'
        },
        {
          className: 'el-icon-suitcase'
        },
        {
          className: 'el-icon-suitcase-1'
        },
        {
          className: 'el-icon-receiving'
        },
        {
          className: 'el-icon-collection'
        },
        {
          className: 'el-icon-files'
        },
        {
          className: 'el-icon-notebook-1'
        },
        {
          className: 'el-icon-notebook-2'
        },
        {
          className: 'el-icon-toilet-paper'
        },
        {
          className: 'el-icon-office-building'
        },
        {
          className: 'el-icon-school'
        },
        {
          className: 'el-icon-table-lamp'
        },
        {
          className: 'el-icon-house'
        },
        {
          className: 'el-icon-no-smoking'
        },
        {
          className: 'el-icon-smoking'
        },
        {
          className: 'el-icon-shopping-cart-full'
        },
        {
          className: 'el-icon-shopping-cart-1'
        },
        {
          className: 'el-icon-shopping-cart-2'
        },
        {
          className: 'el-icon-shopping-bag-1'
        },
        {
          className: 'el-icon-shopping-bag-2'
        },
        {
          className: 'el-icon-sold-out'
        },
        {
          className: 'el-icon-sell'
        },
        {
          className: 'el-icon-present'
        },
        {
          className: 'el-icon-box'
        },
        {
          className: 'el-icon-bank-card'
        },
        {
          className: 'el-icon-money'
        },
        {
          className: 'el-icon-coin'
        },
        {
          className: 'el-icon-wallet'
        },
        {
          className: 'el-icon-discount'
        },
        {
          className: 'el-icon-price-tag'
        },
        {
          className: 'el-icon-news'
        },
        {
          className: 'el-icon-guide'
        },
        {
          className: 'el-icon-male'
        },
        {
          className: 'el-icon-female'
        },
        {
          className: 'el-icon-thumb'
        },
        {
          className: 'el-icon-cpu'
        },
        {
          className: 'el-icon-link'
        },
        {
          className: 'el-icon-connection'
        },
        {
          className: 'el-icon-open'
        },
        {
          className: 'el-icon-turn-off'
        },
        {
          className: 'el-icon-set-up'
        },
        {
          className: 'el-icon-chat-round'
        },
        {
          className: 'el-icon-chat-line-round'
        },
        {
          className: 'el-icon-chat-square'
        },
        {
          className: 'el-icon-chat-dot-round'
        },
        {
          className: 'el-icon-chat-dot-square'
        },
        {
          className: 'el-icon-chat-line-square'
        },
        {
          className: 'el-icon-message'
        },
        {
          className: 'el-icon-postcard'
        },
        {
          className: 'el-icon-position'
        },
        {
          className: 'el-icon-turn-off-microphone'
        },
        {
          className: 'el-icon-microphone'
        },
        {
          className: 'el-icon-close-notification'
        },
        {
          className: 'el-icon-bangzhu'
        },
        {
          className: 'el-icon-time'
        },
        {
          className: 'el-icon-odometer'
        },
        {
          className: 'el-icon-crop'
        },
        {
          className: 'el-icon-aim'
        },
        {
          className: 'el-icon-switch-button'
        },
        {
          className: 'el-icon-full-screen'
        },
        {
          className: 'el-icon-copy-document'
        },
        {
          className: 'el-icon-mic'
        },
        {
          className: 'el-icon-stopwatch'
        },
        {
          className: 'el-icon-medal-1'
        },
        {
          className: 'el-icon-medal'
        },
        {
          className: 'el-icon-trophy'
        },
        {
          className: 'el-icon-trophy-1'
        },
        {
          className: 'el-icon-first-aid-kit'
        },
        {
          className: 'el-icon-discover'
        },
        {
          className: 'el-icon-place'
        },
        {
          className: 'el-icon-location'
        },
        {
          className: 'el-icon-location-outline'
        },
        {
          className: 'el-icon-location-information'
        },
        {
          className: 'el-icon-add-location'
        },
        {
          className: 'el-icon-delete-location'
        },
        {
          className: 'el-icon-map-location'
        },
        {
          className: 'el-icon-alarm-clock'
        },
        {
          className: 'el-icon-timer'
        },
        {
          className: 'el-icon-watch-1'
        },
        {
          className: 'el-icon-watch'
        },
        {
          className: 'el-icon-lock'
        },
        {
          className: 'el-icon-unlock'
        },
        {
          className: 'el-icon-key'
        },
        {
          className: 'el-icon-service'
        },
        {
          className: 'el-icon-mobile-phone'
        },
        {
          className: 'el-icon-bicycle'
        },
        {
          className: 'el-icon-truck'
        },
        {
          className: 'el-icon-ship'
        },
        {
          className: 'el-icon-basketball'
        },
        {
          className: 'el-icon-football'
        },
        {
          className: 'el-icon-soccer'
        },
        {
          className: 'el-icon-baseball'
        },
        {
          className: 'el-icon-wind-power'
        },
        {
          className: 'el-icon-light-rain'
        },
        {
          className: 'el-icon-lightning'
        },
        {
          className: 'el-icon-heavy-rain'
        },
        {
          className: 'el-icon-sunrise'
        },
        {
          className: 'el-icon-sunrise-1'
        },
        {
          className: 'el-icon-sunset'
        },
        {
          className: 'el-icon-sunny'
        },
        {
          className: 'el-icon-cloudy'
        },
        {
          className: 'el-icon-partly-cloudy'
        },
        {
          className: 'el-icon-cloudy-and-sunny'
        },
        {
          className: 'el-icon-moon'
        },
        {
          className: 'el-icon-moon-night'
        },
        {
          className: 'el-icon-dish'
        },
        {
          className: 'el-icon-dish-1'
        },
        {
          className: 'el-icon-food'
        },
        {
          className: 'el-icon-chicken'
        },
        {
          className: 'el-icon-fork-spoon'
        },
        {
          className: 'el-icon-knife-fork'
        },
        {
          className: 'el-icon-burger'
        },
        {
          className: 'el-icon-tableware'
        },
        {
          className: 'el-icon-sugar'
        },
        {
          className: 'el-icon-dessert'
        },
        {
          className: 'el-icon-ice-cream'
        },
        {
          className: 'el-icon-hot-water'
        },
        {
          className: 'el-icon-water-cup'
        },
        {
          className: 'el-icon-coffee-cup'
        },
        {
          className: 'el-icon-cold-drink'
        },
        {
          className: 'el-icon-goblet'
        },
        {
          className: 'el-icon-goblet-full'
        },
        {
          className: 'el-icon-goblet-square'
        },
        {
          className: 'el-icon-goblet-square-full'
        },
        {
          className: 'el-icon-refrigerator'
        },
        {
          className: 'el-icon-grape'
        },
        {
          className: 'el-icon-watermelon'
        },
        {
          className: 'el-icon-cherry'
        },
        {
          className: 'el-icon-apple'
        },
        {
          className: 'el-icon-pear'
        },
        {
          className: 'el-icon-orange'
        },
        {
          className: 'el-icon-coffee'
        },
        {
          className: 'el-icon-ice-tea'
        },
        {
          className: 'el-icon-ice-drink'
        },
        {
          className: 'el-icon-milk-tea'
        },
        {
          className: 'el-icon-potato-strips'
        },
        {
          className: 'el-icon-lollipop'
        },
        {
          className: 'el-icon-ice-cream-square'
        },
        {
          className: 'el-icon-ice-cream-round'
        },
      ],
      isEmpty,
      iconVisible: false,
      params: {
        type: 5
      },
      listParams: {
        tree: true,
        paging: false,
      },
      tableData: [],
      selectData: [],
      dialogVisible: false,
      dictDataSelect: "",
      clickType: "",
      parentId: "",
      treeProps: {
        //配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        // value: "parentId",
        children: "menus",
        label: "name",
      },
      rules: {
        menuId: [{required: true, message: "请选择上一级（必选）",trigger: "change"}],
        name: [
          {required: true, message: "请填写菜单名称", trigger: "change"},
        ],
        view: [{required: false, message: "请填写路由", trigger: "change"}],
        type: [{required: true, message: "请选择类型", trigger: "change"}],
        seq: [
          {type: "number", message: "序号必须为数字值", trigger: "blur",},
        ],
        code: [
          {required: true, message: "请填写标识", trigger: "blur",},
        ],
      },
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true
    };
  },

  created() {
    this.queryTableData();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.dictDataSelect = ""; //上一级回显数据清除
      }
    },
    // 'params.type'(old,val){
    //   if(old!=val){
    //     this.params.code = '';
    //     this.params.seq = '';
    //     this.params.icon = '';
    //     this.params.view = '';
    //     this.params.name = '';
    //   }
    // },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:menu:add') {
            this.addShow = true
          }
          if (item.code == "system:menu:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:menu:edit") {
            this.editShow = true
          }
          if (item.code == "system:menu:status") {
            this.statusShow = false
          }
        })
      }
    },

    changActive(e) {
      this.params.icon = e.className
      this.iconVisible = false
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;

      const {data: resData} = await this.$get("menu/list", {
        params: this.listParams,
      });
      this.loading = false;
      if (resData.result != 200) return;

      // resData.data.forEach((element) => {
      //   if (element.menus) {
      //     this.tableData = element.menus
      //   }
      // });
      this.tableData = resData.data
      this.selectData = resData.data;

      if (resData.data.length == 0) this.tableData = [];
    },

    async changeSwitch(b) {
      const {data: resData} = await this.$put(`menu/info/status/${b.menuId}`);
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },

    /**
     * 表格按钮点击
     */
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;

      if (type == "edit") {
        //编辑
        this.$nextTick(() => {
          //回显上一级
          let temp = this.$refs.TreeList.getNode(row.menuId).parent.data.name
          this.dictDataSelect = temp
        })

        this.params = JSON.parse(JSON.stringify(row))

      } else if (type == "add") {
        //添加下一级
        this.params = {type: 5};
      } else {
        //添加
        // this.params = { parentId: 0 };
      }
    },
    /**
     * 编辑
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;

        if (isEmpty(this.dictDataSelect)) {
          this.params.parentId = 0
          // return this.$message.warning("请选择上一级!");
        }


        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {

          if (this.clickType == "add" || this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "menu/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
            // this.$emit('handleMenuClick')
          } else {
            const {data: resData} = await this.$put(
                "menu/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.params.parentId = node.menuId;
      this.$refs.selectReport.blur();
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `menu/info/${row.menuId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;
        this.queryTableData();

        this.$message.success("删除成功!");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: -63px;
  top: 0;
}
.organization {
  .public-table-but {
    padding-top: 10px;
  }

  .el-table th .cell {
    text-align: center;
  }
}

.from_box {
  display: flex;
  align-items: center;
}

.icon-list {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #eee;
  border-right: 0;
  border-bottom: 0;
  margin-bottom: 30px;
  cursor: pointer;

  li {
    width: 16.66%;
    text-align: center;
    height: 120px;
    color: #666;
    font-size: 13px;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: center;

    i {
      display: block;
      font-size: 32px;
      margin-bottom: 15px;
      color: #606266;
    }
  }

  li:hover span {
    color: #5cb6ff;
  }

  li:hover i {
    color: #5cb6ff;
  }

  .active_info span {
    color: #5cb6ff;
  }

  .active_info i {
    color: #5cb6ff;
  }
}

</style>